import { BaseService } from "./BaseService";

export class InvestorService extends BaseService {
  getInvestors(profileId) {
    return super.invokeGet(this.APICONFIG.APIBASEURL + this.APICONFIG.GETINVESTORS + "?profileID=" + profileId);
  }
}
